export function DocTienBangChu() {
  this.ChuSo = new Array("không","một","hai","ba","bốn","năm","sáu","bảy","tám","chín");
  this.Tien = new Array("", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ");
};

DocTienBangChu.prototype.capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

DocTienBangChu.prototype.docSo3ChuSo = function (baso) {
	var tram;
    var chuc;
    var donvi;
    var KetQua = [];
    tram = parseInt(baso / 100);
    chuc = parseInt((baso % 100) / 10);
    donvi = baso % 10;
    if (tram == 0 && chuc == 0 && donvi == 0) return KetQua;
    if (tram != 0) {
        KetQua.push(this.ChuSo[tram]);
        KetQua.push("trăm");
        if ((chuc == 0) && (donvi != 0)) KetQua.push("linh");
    }
    if ((chuc != 0) && (chuc != 1)) {
        KetQua.push(this.ChuSo[chuc]);
        KetQua.push("mươi");
        if ((chuc == 0) && (donvi != 0)) KetQua.push("linh");
    }
    if (chuc == 1) KetQua.push("mười");
    switch (donvi) {
        case 1:
            if ((chuc != 0) && (chuc != 1)) {
                KetQua.push("mốt");
            }
            else {
                KetQua.push(this.ChuSo[donvi]);
            }
            break;
        case 5:
            if (chuc == 0) {
                KetQua.push(this.ChuSo[donvi]);
            }
            else {
                KetQua.push("lăm");
            }
            break;
        default:
            if (donvi != 0) {
                KetQua.push(this.ChuSo[donvi]);
            }
            break;
    }
    return KetQua;
}

DocTienBangChu.prototype.doc = function (SoTien) {
	var lan = 0;
    var i = 0;
    var so = 0;
    var KetQua = [];
    var tmp = [];
    var soAm = false;
    var ViTri = new Array();
    if (SoTien < 0) soAm = true;//return "Số tiền âm !";
    if (SoTien == 0) return "Không đồng";//"Không đồng !";
    if (SoTien > 0) {
        so = SoTien;
    }
    else {
        so = -SoTien;
    }
    if (SoTien > 8999999999999999) {
        //SoTien = 0;
        return "";//"Số quá lớn!";
    }
    ViTri[5] = Math.floor(so / 1000000000000000);
    if (isNaN(ViTri[5]))
        ViTri[5] = "0";
    so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
    ViTri[4] = Math.floor(so / 1000000000000);
    if (isNaN(ViTri[4]))
        ViTri[4] = "0";
    so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
    ViTri[3] = Math.floor(so / 1000000000);
    if (isNaN(ViTri[3]))
        ViTri[3] = "0";
    so = so - parseFloat(ViTri[3].toString()) * 1000000000;
    ViTri[2] = parseInt(so / 1000000);
    if (isNaN(ViTri[2]))
        ViTri[2] = "0";
    ViTri[1] = parseInt((so % 1000000) / 1000);
    if (isNaN(ViTri[1]))
        ViTri[1] = "0";
    ViTri[0] = parseInt(so % 1000);
    if (isNaN(ViTri[0]))
        ViTri[0] = "0";
    if (ViTri[5] > 0) {
        lan = 5;
    }
    else if (ViTri[4] > 0) {
        lan = 4;
    }
    else if (ViTri[3] > 0) {
        lan = 3;
    }
    else if (ViTri[2] > 0) {
        lan = 2;
    }
    else if (ViTri[1] > 0) {
        lan = 1;
    }
    else {
        lan = 0;
    }
    for (i = lan; i >= 0; i--) {
        tmp = this.docSo3ChuSo(ViTri[i]);
        KetQua = KetQua.concat(tmp);
        if (ViTri[i] > 0 && this.Tien[i] != '') KetQua.push(this.Tien[i]);
    }
    KetQua.push("đồng");
    if (soAm) {
        return "Âm " + KetQua.join(" ");//.substring(0, 1);//.toUpperCase();// + KetQua.substring(1);
    }
    else {
        return this.capitalizeFirstLetter(KetQua.join(" "));//.substring(0, 1);//.toUpperCase();// + KetQua.substring(1);
    }
}